var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM6.53033 12.455C6.23744 12.7479 6.23744 13.2227 6.53033 13.5156L9.18198 16.1673C9.76777 16.7531 10.7175 16.7531 11.3033 16.1673L18.1976 9.27298C18.4905 8.98009 18.4905 8.50521 18.1976 8.21232C17.9047 7.91943 17.4298 7.91943 17.1369 8.21232L10.5608 14.7884C10.3851 14.9641 10.1002 14.9641 9.92444 14.7884L7.59099 12.455C7.2981 12.1621 6.82322 12.1621 6.53033 12.455Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/success.b8d408867538f9f55219c937c2e476fc.svg";